import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSnackBarStore = defineStore('snackBar', () => {
  const snackBar = ref(false);
  const snackBarMessage = ref('');
  const snackBarColor = ref('');
  function showSnackBar(message: string, color: string) {
    snackBarMessage.value = message;
    snackBarColor.value = color;
    snackBar.value = true;
  }

  return { snackBar, snackBarMessage, snackBarColor, showSnackBar };
});
